import React from "react";
import styled from "@emotion/styled";
import Paper from "@mui/material/Paper";

import { ZoomInMap as ZoomInMapIcon } from "@mui/icons-material";

const Container = styled(Paper)<{ disabled?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 14px;
  padding-left: 14px;
  width: 40px;
  cursor: pointer;
`;

const StyledIcon = styled(ZoomInMapIcon)`
  width: 27px;
  height: auto;
`;

type Props = {
  recenter: React.MouseEventHandler<HTMLDivElement>;
  disabled?: boolean;
};

function RecenterButton({ recenter, disabled }: Props): JSX.Element {
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!disabled) {
      recenter(event);
    }
  };

  return (
    <Container onClick={handleClick} disabled={disabled}>
      <StyledIcon />
    </Container>
  );
}

RecenterButton.defaultProps = {
  disabled: false,
};

export default RecenterButton;
